import { getPartners } from "@/common/services/partners.api";
import { IPartner } from "@/types/partners.type";
import { useQuery } from "@tanstack/react-query";

export const useGetPartners = () => {
  // const currentUF = useCompanyStore((state) => state.selectedUf) || ""
  return useQuery<IPartner[], Error>({
    queryKey: ["partners"],
    queryFn: async () => {
      const response = await getPartners({ itemsPerPage: 100 });
      if (!response.data) {
        throw new Error("Erro ao buscar partners");
      }
      return response.data;
    },
  });
};
